import { Roles } from "@arelia-types/index";
import { SortOrder } from "@arelia-types/data-models";
import { Subscription, SubscriptionPlan } from "@arelia-types/subscriptions";

export interface Customer {
  identityId: string;
  email: string;
  role: Roles,
  fullName: string;
  avatarUrl: string;
  phone: string;
  address: string;
  status: CustomerStatus,
  createdDate: string;
  band: Band;
  customerInfo: string;
  partitionKey: string;
  id: string;
  displayName?: string;
  subscription: Subscription;
}

export interface Band {
  labelOrManager: string;
  location: string;
  members: string[];
  name: string;
}

export enum CustomersSorting {
  createdDateAsc = "createdDateAsc",
  createdDateDesc = "createdDateDesc",
  nameAsc = "nameAsc",
  nameDesc = "nameDesc",
}

export type SortOrderMap = {
  [key in CustomersSorting]: SortOrder;
}

export type SortValueGetterMap = {
  [key in CustomersSorting]: (customer: Customer) => string | Date;
}

export interface CustomerDetails {
  id: string;
  identityId: string;
  email: string;
  role: Roles;
  fullName: string;
  avatarUrl: string;
  backgroundUrl: string;
  captureFormBackgroundUrl: string;
  phone: string;
  address: string;
  status: CustomerStatus;
  createdDate: string;
  plan: SubscriptionPlan;
  subscription: Subscription;
  band: {
    location: string;
    labelOrManager: string;
    name: string;
    members: {
      name: string;
      role: string;
    }[];
  };
  customerInfo: {
    leadSource: string;
    notes: string;
    initialPassword: string;
    social: {
      name: string;
      url: string;
    }[];
  };
  partitionKey: string;
}

export type Tag = {
  prop: keyof Customer;
  val: string;
}

export enum CustomerStatus {
  Registered = "Registered",
  Active = "Active",
  Inactive = "Inactive",
  Closed = "Closed"
}

export type CxActivity = {
  date: string;
  activityName: string;
  note: string;
}